module.exports = __webpack_public_path__ + "img/left_icon.3cd4e2ae.png";